module.exports = __webpack_public_path__ + "res/Roboto-MediumItalic-webfont.eot?bcaffef1a7ab1064a99730dba794f3ad";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-MediumItalic-webfont.eot
// module id = 81
// module chunks = 0